import {
  API_ACCESS_ERROR,
  API_ACCESS_LOADING,
  API_ACCESS_SAVING,
  API_ACCESS_SET,
  LOGOUT,
} from "../types";
import { stripSecrets } from "../../utils/apiAccessSafety";

/*
    API Access (static#49).

    This slice holds ONLY the secret-free GET /api-access shape. The IAM secret
    access key and access key id returned by provision/rotate live in local
    component state in components/setting/ApiAccess.js and never come here —
    src/store/index.js persists `authUser` to localStorage under a hardcoded AES
    key, and adding another persisted path for credentials would be a disclosure
    bug. `stripSecrets` below is the guard that makes that structural rather
    than a convention.
*/

const initialState = {
  loading: false, // the initial GET is in flight
  saving: false, // provision / rotate / call-limit is in flight
  loaded: false, // the GET has resolved at least once
  error: null, // a plain string, never an error object
  data: null, // the GET /api-access payload, secret-free
};

export default function apiAccessReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case API_ACCESS_LOADING:
      return { ...state, loading: !!payload };
    case API_ACCESS_SAVING:
      return { ...state, saving: !!payload };
    case API_ACCESS_SET:
      return {
        ...state,
        // Defence in depth: even if a caller hands us a provision
        // response by mistake, the credentials are dropped here.
        data: stripSecrets(payload),
        loaded: true,
        error: null,
      };
    case API_ACCESS_ERROR:
      return {
        ...state,
        error: typeof payload === "string" ? payload : null,
        loaded: true,
      };
    case LOGOUT:
      // The panel skips its spinner while `loaded` is true, so a second
      // customer signing in without a reload would see the previous one's
      // key id and usage until the new GET resolves. Drop it on logout.
      return initialState;
    default:
      return state;
  }
}
